// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { CompassWidget as _CompassWidget } from '@deck.gl/widgets';
import { useWidget } from "../utils/use-widget.js";
export const CompassWidget = (props = {}) => {
    useWidget(_CompassWidget, props);
    return null;
};
//# sourceMappingURL=compass-widget.js.map